import { DateTime } from 'luxon';

import { CreateAdCampaignRequest, PatchAdCampaignRequest } from 'apis/ad-bookings/types';
import { convertDecimalToMonetaryInt } from 'common/utils/currencyDecimals';

import { AdCampaignFormValues } from '../../types';

export type TransformAdCampaignFormFieldsToApiProps = AdCampaignFormValues & {
  country: Country;
  currency: Currency;
};

export const transformAdCampaignFormFieldsToApi = (
  values: TransformAdCampaignFormFieldsToApiProps,
): CreateAdCampaignRequest => ({
  country: values.country,
  start_date: DateTime.fromISO(values.startDate).toFormat('yyyy-MM-dd'),
  end_date:
    values.scheduleStrategy === 'selectDates' && values.endDate
      ? DateTime.fromISO(values.endDate).toFormat('yyyy-MM-dd')
      : null,
  weekly_budget_amount: convertDecimalToMonetaryInt(Number(values.budgetAmount), values.currency),
  bid_amount:
    values.bidStrategy === 'custom'
      ? convertDecimalToMonetaryInt(Number(values.customBidAmount), values.currency)
      : undefined,
  bid_strategy: values.bidStrategy === 'custom' ? 'CUSTOM' : 'AUTOMATIC',
  consent: values.agreementTermsAndConditions,
});

export const transformAdCampaignFormFieldsToUpdateApi = (
  values: TransformAdCampaignFormFieldsToApiProps,
): PatchAdCampaignRequest => ({
  start_date: values.startDate ? DateTime.fromISO(values.startDate).toFormat('yyyy-MM-dd') : undefined,
  end_date: values.endDate ? DateTime.fromISO(values.endDate).toFormat('yyyy-MM-dd') : undefined,
  weekly_budget_amount: values.budgetAmount
    ? convertDecimalToMonetaryInt(Number(values.budgetAmount), values.currency)
    : undefined,
  bid_amount:
    values.bidStrategy === 'custom'
      ? convertDecimalToMonetaryInt(Number(values.customBidAmount), values.currency)
      : undefined,
  bid_strategy: values.bidStrategy ? (values.bidStrategy === 'custom' ? 'CUSTOM' : 'AUTOMATIC') : undefined,
  always_on: values.scheduleStrategy === 'alwaysOn' ? true : undefined,
});
